import React from "react";

/**
 * RC10m · Driver selector amber chip.
 *
 * Rendered on rows whose eligibility payload includes a
 * `MEDICAL_EXPIRING_DURING_TOUR` warning_reason. Smaller inline chip
 * distinct from the RC10l RED Unavailable badge and the amber
 * Coverage Needed card — this one surfaces the compliance follow-up
 * at selector time; the full verbatim wording is enforced in the
 * acknowledgment modal on save.
 */
function fmtMMDDYYYY(iso) {
  if (!iso || typeof iso !== "string") return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${m}/${d}/${y}`;
}

export function MedicalExpiringDuringTourChip({ eligibility, testid }) {
  const warn = (eligibility?.warning_reasons || []).find(
    (w) => w && w.code === "MEDICAL_EXPIRING_DURING_TOUR",
  );
  if (!warn) return null;
  const exp = (warn.context || {}).medical_card_expiration;
  return (
    <span
      data-testid={testid || "rc10m-chip-medical-expiring-during-tour"}
      title={warn.message || "Medical Card expires during the requested tour window"}
      className="inline-flex items-center border rounded-sm px-1.5 py-0.5 text-[10px] uppercase tracking-widest font-medium bg-amber-hold/15 text-amber-hold border-amber-hold/50 whitespace-nowrap"
    >
      Medical expires {fmtMMDDYYYY(exp)} during tour
    </span>
  );
}

/**
 * Returns true if the eligibility payload trips Rule 2 (medical
 * expiration overlaps the requested tour window). Callers use this
 * to decide whether to open the acknowledgment modal vs. direct
 * submit.
 */
export function hasMedicalExpiryDuringTour(eligibility) {
  if (!eligibility) return false;
  const list = eligibility.warning_reasons || [];
  for (const w of list) {
    if (w && w.code === "MEDICAL_EXPIRING_DURING_TOUR") return true;
  }
  return false;
}

/**
 * Extracts the ISO date (YYYY-MM-DD) from a MEDICAL_EXPIRING_DURING_TOUR
 * warning_reason, or null.
 */
export function medicalExpiryDateFrom(eligibility) {
  if (!eligibility) return null;
  const w = (eligibility.warning_reasons || []).find(
    (x) => x && x.code === "MEDICAL_EXPIRING_DURING_TOUR",
  );
  return (w && w.context && w.context.medical_card_expiration) || null;
}
